import React, { useEffect } from "react"
import Container from "@material-ui/core/Container"
import clsx from "clsx"
import { Link, useLocation, useHistory } from "react-router-dom"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Tooltip, Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import Drawer from "@material-ui/core/Drawer"
import { useDispatch } from "react-redux"
import List from "@material-ui/core/List"
import IconButton from "@material-ui/core/IconButton"
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight"
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import { drawerWidth } from "../../../utils/constants"
import SuperSetMenu from "./DrawerMenu"
import LogoutSVG from "../../../components/icons/LogoutSVG"
import { logoutUser, logoutClearStore, logoutUserAction } from "../../../actions/userActions"
import { clearMultibase } from "../../../actions/multiAiBase"
import { clearLocalStorage, LOCAL_STORAGE_KEYS, usePermissions, ROUTES, buildQueryString } from "../../../utils"
import { setFilterJobId } from "../../../actions/filterActions"
import { getInfo } from "../../../actions/infoActions"
import VERSION from "../../../application_version.json"
import { reSetReview } from "../../../actions/reviewActions"

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	button: {
		width: "100%",
	},
	hide: {
		display: "none",
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
	},
	drawerOpen: {
		top: "64px",
		width: drawerWidth,
		borderRight: `solid 1px ${theme.palette.grey.D200}`,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerClose: {
		top: "64px",
		borderRight: `solid 1px ${theme.palette.grey.D200}`,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: "hidden",
		width: "50px",
		[theme.breakpoints.up("sm")]: {
			width: "50px",
		},
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
		position: "relative",
		...theme.mixins.toolbar,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},

	menuItem: {
		borderLeft: `solid 5px ${theme.palette.common.white}`,
		"&:hover": {
			backgroundColor: theme.palette.primary.light,
			borderLeft: `solid 5px ${theme.palette.primary.dark}`,
		},
		"& .MuiListItemIcon-root": {
			color: theme.palette.grey.D300,
		},
		"&.Mui-selected": {
			backgroundColor: theme.palette.action.selected,
			borderLeft: `solid 5px ${theme.palette.primary.dark}`,
			"& .MuiListItemIcon-root": {
				color: theme.palette.primary.dark,
			},
			"& .MuiListItemText-primary": {
				color: theme.palette.text.selected,
				fontWeight: "600",
			},
			"& .MuiButtonBase-root": {
				border: "none",
			},
			"&:hover": {
				backgroundColor: theme.palette.action.active,
				"& .MuiListItemText-primary": {
					color: theme.palette.text.selected,
				},
			},
		},
	},
}))

const WithDrawer = (WrappedComponent) => {
	return () => {
		const classes = useStyles()
		const theme = useTheme()
		const [open, setOpen] = React.useState(false)
		const location = useLocation()
		const history = useHistory()
		const dispatch = useDispatch()
		const [t] = useTranslation("global")
		const { isLogout } = useSelector((state) => state?.authtentication)
		const filterJobId = useSelector((state) => state.filter?.filterJobId)
		const version = useSelector((state) => state?.info?.version)
		const jobIdPaths = [ROUTES.TIMELINE, ROUTES.VIEW_DOCUMENTS, ROUTES.BUILD_CONCEPTS]
		const retainedFilterJobData = useSelector((state) => state.info?.retainedFilterJobData)

		const { hasPermission } = usePermissions()

		useEffect(() => {
			dispatch(getInfo())
		}, [])

		const handleLogout = (e) => {
			dispatch(logoutUserAction())
		}

		useEffect(() => {
			if (isLogout) {
				dispatch(logoutClearStore())
				dispatch(logoutUser())
				clearLocalStorage()
				dispatch(clearMultibase())
			}
		}, [isLogout])

		// useEffect(() => {
		// 	if (filterJobId) {
		// 		const path = location?.pathname?.split("/")
		// 		if (path?.includes("viewer")) {
		// 			history.push(`${path?.[0]}/${path?.[1]}/${filterJobId}/viewer/${path?.[4]}`)
		// 		} else {
		// 			if (jobIdPaths.includes(`/${path?.[1]}`)) history.push(`${path?.[0]}/${path?.[1]}/${filterJobId}`)
		// 		}
		// 		dispatch(setFilterJobId())
		// 	}
		// }, [filterJobId])

		useEffect(() => {
			if (!_.isEmpty(retainedFilterJobData)) {
				const queryString = buildQueryString(retainedFilterJobData)
				const url = `${window.location.pathname}?${queryString}`
				history.push(url)
			}
		}, [retainedFilterJobData])

		useEffect(() => {
			dispatch(setFilterJobId())
		}, [location?.pathname])

		const toggle = () => setOpen(!open)

		const NavigateTo = (route) => {
			dispatch(reSetReview())
			history.push(route)
		}

		return (
			<div className={classes.root}>
				<Drawer
					variant="permanent"
					className={clsx(classes.drawer, {
						[classes.drawerOpen]: open,
						[classes.drawerClose]: !open,
					})}
					classes={{
						paper: clsx({
							[classes.drawerOpen]: open,
							[classes.drawerClose]: !open,
						}),
					}}
				>
					<Box className={classes.toolbar}>
						<IconButton
							style={{
								boxShadow: theme.shadows[2],
								width: "24px",
								height: "24px",
								borderRadius: "50%",
								position: "absolute",
							}}
							onClick={toggle}
						>
							{open ? <KeyboardArrowLeftIcon color="primary" /> : <KeyboardArrowRightIcon color="primary" />}
						</IconButton>
					</Box>
					<List>
						{SuperSetMenu.map((menu, index) => {
							if (hasPermission(menu?.permissions)) {
								return (
									<Tooltip title={open ? "" : menu.title} placement="top">
										<ListItem
											color="primary"
											style={{
												padding: 0,
												margin: 0,
											}}
											className={classes.menuItem}
											selected={location.pathname.includes(menu?.route)}
											key={`${menu?.key}-${index}`}
											disablePadding
										>
											<Button
												key={menu.key}
												//to={menu.route}
												//component={Link}
												onClick={() => NavigateTo(menu.route)}
												color="primary"
												style={{
													...theme.typography.body2,
													minHeight: theme.mixins.toolbar.minHeight,
													textTransform: "capitalize",
													justifyContent: open ? "initial" : "center",
													px: 2.5,
													width: "100%",
												}}
											>
												<ListItemIcon
													style={{
														minWidth: 0,
														marginRight: open ? "16px" : "auto",
													}}
												>
													{menu.icon}
												</ListItemIcon>
												<ListItemText
													className={`qa-sidebar-${menu.key}`}
													style={{ opacity: open ? 1 : 0, display: "flex" }}
												>
													{menu.title}
												</ListItemText>
											</Button>
										</ListItem>
									</Tooltip>
								)
							}
						})}
					</List>
					<div style={{ position: "absolute", bottom: "70px", width: "100%" }}>
						<List>
							<ListItem
								color="primary"
								style={{
									padding: 0,
									margin: 0,
									width: "100%",
								}}
								key={1}
								disablePadding
							>
								<Tooltip title={open ? "" : "Logout"} placement="top">
									<Button color="primary" onClick={handleLogout} className={classes.button}>
										<ListItemIcon
											style={{
												minWidth: 0,
												marginRight: open ? "16px" : "auto",
												transform: "rotate(180deg)",
											}}
										>
											<LogoutSVG />
										</ListItemIcon>
										<ListItemText
											className={`qa-sidebar-logout`}
											style={{
												...theme.typography.body2,
												opacity: open ? 1 : 0,
												textTransform: "capitalize",
												display: "flex",
											}}
										>
											{t("drawer.logout")}
										</ListItemText>
									</Button>
								</Tooltip>
							</ListItem>
							<div
								color="primary"
								style={{
									...theme.typography.body2,
									opacity: open ? 1 : 0,
									textTransform: "capitalize",
									marginLeft: "40px",
								}}
							>
								<Typography>{`${t("drawer.fe")} - ${VERSION?.versions?.REACT_VERSION}`}</Typography>
								<Typography>{`${t("drawer.be")} - ${version?.api_version || ""}`}</Typography>
							</div>
						</List>
					</div>
				</Drawer>
				<Container className="container" maxWidth="xl" style={{ padding: "0 32px", margin: 0 }}>
					<WrappedComponent />
				</Container>
			</div>
		)
	}
}

export default WithDrawer
